import { UnsavedChangesModalConsts } from 'client/util/Constants';
import LoggingService from 'client/util/LoggingService';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

export class ModalUtil {
  constructor(theModalEventBus = ModalEventBus) {
    this.ModalEventBus = theModalEventBus;
  }

  openModal(modalConfig) {
    const {
      component = 'ConfirmationModal',
      componentProps = {},
      isLargeModal = false,
      preventCloseOnOverlayClick = true,
    } = modalConfig;

    this.ModalEventBus.open({
      isLargeModal,
      component,
      componentProps,
      preventCloseOnOverlayClick,
    });
  }

  unSavedChangesModal(handleUnSavedChanges) {
    LoggingService.debug('ModalUtil.unSavedChangesModal: ', handleUnSavedChanges);
    const { bodyText, headerText } = UnsavedChangesModalConsts;

    const handleContinue = () => {
      LoggingService.debug('ModalUtil.unSavedChangesModal.handleContinue');
      handleUnSavedChanges();
      LoggingService.debug('ModalUtil.unSavedChangesModal.handleContinue closing Modal');
      this.ModalEventBus.close();
    };

    const handleCancel = () => {
      handleUnSavedChanges(false);
      this.ModalEventBus.close();
    };

    const modalConfig = {
      componentProps: {
        headerText,
        bodyText,
        handleCancel: () => handleCancel(),
        handleContinue: () => handleContinue(),
        showClose: false,
      },
    };

    this.openModal(modalConfig);
  }
}

const modalUtil = new ModalUtil();

export default modalUtil;
